export const MANUAL_ASSESSMENT_CONTACT_SUPPORT_HINT =
  "Please contact the support team for assistance.";

export type HttpStatusError = Error & { httpStatus?: number };

export function getHttpStatusFromError(error: unknown): number | undefined {
  if (!error || typeof error !== "object" || !("httpStatus" in error)) {
    return undefined;
  }
  const status = (error as HttpStatusError).httpStatus;
  return typeof status === "number" ? status : undefined;
}

export function formatManualAssessmentInitiateErrorMessage(
  message: string,
  httpStatus?: number,
): string {
  if (httpStatus !== 400) {
    return message.trim();
  }

  const trimmed = message.trim();
  const base =
    trimmed || "Bad request. Please check your input and try again.";
  if (
    base.toLowerCase().includes("support team") ||
    base.toLowerCase().includes("contact support")
  ) {
    return base;
  }
  const withPunctuation = base.endsWith(".") ? base : `${base}.`;
  return `${withPunctuation} ${MANUAL_ASSESSMENT_CONTACT_SUPPORT_HINT}`;
}

export function resolveManualAssessmentInitiateError(
  error: unknown,
  fallback: string,
): string {
  const httpStatus = getHttpStatusFromError(error);
  // Only surface backend copy for HTTP 400 (client/input issues). For 5xx and
  // other failures, prefer the caller’s contextual fallback.
  if (httpStatus === 400 && error instanceof Error) {
    return formatManualAssessmentInitiateErrorMessage(
      error.message,
      httpStatus,
    );
  }
  return formatManualAssessmentInitiateErrorMessage(fallback, httpStatus);
}
